import Swiper from "swiper";
import { Keyboard, Mousewheel, Navigation } from "swiper/modules";
import "swiper/css";

const initProjectsSlider = () => {
  const sliderEl = document.querySelector(".projects__slider");
  if (!sliderEl) return;

  const sectionEl = sliderEl.closest(".projects");
  const prevEl = sectionEl?.querySelector(".projects__btn--prev");
  const nextEl = sectionEl?.querySelector(".projects__btn--next");

  new Swiper(sliderEl, {
    modules: [Keyboard, Mousewheel, Navigation],
    slidesPerView: 1,
    spaceBetween: 20,
    watchOverflow: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
    },
    navigation: {
      prevEl,
      nextEl,
    },
    breakpoints: {
      993: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });
};

export default initProjectsSlider;
